import classNames from 'classnames';
import type { FC, HTMLAttributes } from 'react';

import styles from './thead-multi.module.scss';

export interface THeadMultiProps extends HTMLAttributes<HTMLTableSectionElement> {
  isSticky?: boolean;
  multiChildren?: React.ReactNode;
  isChildrenLast?: boolean;
}

export const THeadMulti: FC<THeadMultiProps> = ({
  children,
  isSticky,
  multiChildren,
  isChildrenLast,
  ...props
}) => (
  <thead className={classNames(styles.root, { [styles.sticky]: isSticky })} {...props}>
    <tr
      className={classNames(styles.thead_tr, {
        [styles['thead_tr-shown']]: !!multiChildren,
        [styles['thead_tr-last']]: isChildrenLast,
      })}
    >
      {children}
    </tr>
    {multiChildren && (
      <tr
        className={classNames(styles['thead_tr-multi'], {
          [styles['thead_tr-multi--last']]: isChildrenLast,
        })}
      >
        {multiChildren}
      </tr>
    )}
  </thead>
);
